function enhanceComparison(section) {
  if (section.dataset.pdpComparisonEnhanced === 'true') return;

  const tableWrapper = section.querySelector('.vs-rest-table-responsive-wrapper');
  const table = tableWrapper?.querySelector('.vs-rest-comparison-table');
  const columns = table?.querySelectorAll('thead th');

  if (!tableWrapper || !table || columns?.length !== 5) return;

  const controls = document.createElement('div');
  controls.className = 'pdp-vs-rest-mobile-compare-controls';
  controls.setAttribute('aria-label', 'Choose a product to compare with AutoFlosser');

  const label = document.createElement('p');
  label.className = 'pdp-vs-rest-mobile-compare-label';
  label.textContent = 'Compare AutoFlosser with:';

  const buttons = document.createElement('div');
  buttons.className = 'pdp-vs-rest-mobile-compare-buttons';
  buttons.setAttribute('role', 'group');
  buttons.setAttribute('aria-label', 'Competitor selection');

  const competitors = [
    { key: 'picks', label: 'Floss Picks' },
    { key: 'threader', label: 'Threader' },
    { key: 'floss', label: 'Dental Floss' },
  ];

  competitors.forEach(({ key, label: buttonLabel }, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'pdp-vs-rest-mobile-compare-button';
    button.dataset.pdpComparisonCompetitor = key;
    button.textContent = buttonLabel;
    button.setAttribute('aria-pressed', String(index === 0));
    buttons.append(button);
  });

  controls.append(label, buttons);
  tableWrapper.before(controls);
  section.dataset.pdpComparisonEnhanced = 'true';
  section.dataset.pdpComparison = 'picks';

  buttons.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pdp-comparison-competitor]');
    if (!button) return;

    section.dataset.pdpComparison = button.dataset.pdpComparisonCompetitor;
    buttons.querySelectorAll('[data-pdp-comparison-competitor]').forEach((item) => {
      item.setAttribute('aria-pressed', String(item === button));
    });
  });
}

function initializePdpComparisons(scope = document) {
  const sections = scope.querySelectorAll?.(
    'main[data-template*="product"] .autoflosser-vs-rest-section-wrapper'
  );
  sections?.forEach(enhanceComparison);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializePdpComparisons());
} else {
  initializePdpComparisons();
}

document.addEventListener('shopify:section:load', (event) => initializePdpComparisons(event.target));
